module.exports = __webpack_public_path__ + "static/media/exportIcon.db750703.svg";